module.exports = __webpack_public_path__ + "img/42.7ee61430.jpg";